module.exports = __webpack_public_path__ + "static/media/spectrum_business_logo.579eacf6.svg";